var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":function($event){return _vm.switchTheme()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-theme-light-dark")]),_vm._v(" Zmień motyw ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }